import React from 'react';
import { FiSearch, FiX } from 'react-icons/fi';
import styles from '../AnnouncementsV2.module.css';

const SearchBar = ({ value, onChange, onClear }) => {
  return (
    <div className={styles.searchBar}>
      <FiSearch size={18} className={styles.searchIcon} />
      <input
        type="text"
        className={styles.searchInput}
        placeholder="Search announcements by title, content, or author..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {value && (
        <button className={styles.clearButton} onClick={onClear}>
          <FiX size={18} />
        </button>
      )}
    </div>
  );
};

export default SearchBar;
